import styled from 'styled-components';

export const MobileAssetInfoHeaderStyled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 12px;
    max-width: 100%;
    overflow: hidden;
    align-items: center;

    .col-left {
        font-size: 28px;
    }

    .col-center {
        flex: 1;
        overflow: hidden;
        text-align: left;

        * {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }

    .col-right {
        font-size: 16px;
    }
`;

export const SliderMobileModalHeaderStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
`;
